import type { CollectibleElastic } from "@/services/collectibles/elastic/collectiblesElasticTypes";
import { gettext } from "@/services/translation";
import { ImageSize } from "@/services/images";

export type Param = {
  name: string;
  value: string | number | undefined;
};

/** @todo rework into composable */
export const getCollectibleElasticParams = (colletibleElastic: CollectibleElastic): Param[] => {
  const params: Param[] = [];

  const theme = colletibleElastic.theme;
  if (theme !== null) {
    params.push({
      name: gettext.$gettext("Edice"),
      value: theme.name,
    });
  }

  colletibleElastic.parameters.forEach((param) => {
    const value = param.value === null ? undefined : param.value;
    const name = param.name;
    params.push({ name, value });
  });

  return params;
};

export const getCollectiblePreviewUrl = (collectible: CollectibleElastic): string | undefined => {
  const image = collectible.images[0];
  if (!image) return undefined;
  const sizeUrls = image.imageUrl[ImageSize["467x350"]] ?? image.imageUrl[ImageSize["310x233"]] ?? Object.values(image.imageUrl)[0];
  return Object.values(sizeUrls ?? {})[0];
};
